import dayjs from 'dayjs';
import { IEquipment } from './equipment.model';
import { IUserInfo } from './user-info.model';
import { useUniqueId } from '@dnd-kit/utilities';
import { v4 as uuidv4 } from 'uuid';
import { IROI } from './roi.model';

export interface IThermogram {
  id?: string;
  imagePath?: string;
  audioPath?: string | null;
  imageRefPath?: string;
  minTemp?: number | null;
  avgTemp?: number | null;
  maxTemp?: number | null;
  emissivity?: number | null;
  subjectDistance?: number | null;
  atmosphericTemp?: number | null;
  reflectedTemp?: number | null;
  relativeHumidity?: number | null;
  cameraLens?: string | null;
  cameraModel?: string | null;
  imageResolution?: string | null;
  selectedRoiId?: string | null;
  maxTempRoi?: number | null;
  createdAt?: dayjs.Dayjs | null;
  latitude?: number | null;
  longitude?: number | null;
  equipment?: IEquipment | null;
  createdBy?: IUserInfo | null;
  rois?: IROI[];
}

// Factory function to create a new thermogram with a unique ID
export const createDefaultThermogram = (): IThermogram => ({
  id: uuidv4(),
  imagePath: '',
  audioPath: null,
  imageRefPath: '',
  minTemp: 0,
  avgTemp: 0,
  maxTemp: 0,
  emissivity: 0,
  subjectDistance: 0,
  atmosphericTemp: 0,
  reflectedTemp: 0,
  relativeHumidity: 0,
  cameraLens: '',
  cameraModel: '',
  imageResolution: '',
  selectedRoiId: null,
  maxTempRoi: 0,
  createdAt: null,
  latitude: 0,
  longitude: 0,
  equipment: null,
  createdBy: null,
  rois: []
});
